const logLevels = ['error', 'warn', 'info', 'debug'] as const;

export type LogLevel = (typeof logLevels)[number];
export type LogFunction = (input: any) => void;
export type Logger = Record<LogLevel, LogFunction>;

export const defaultLogger: Logger = console;
